<template>
  <div>
    <v-dialog
      v-model="dialog"
      flat
      persistent
      max-width="1000"
      content-class="br_none"
    >
      <v-row class="modal__content__wrapper">
        <v-col cols="12" class="pa-0">
          <div class="header__wrap">
            <div>
              <h2 class="modal__title">{{$t('user.agent.detail.title')}}</h2>
            </div>
            <div class="modal__close__wrap">
              <v-btn @click="$emit('close')"></v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <v-form
            lazy-validation
            data-vv-scope="scope_profile"
          >
            <div class="login_form type2 type3 pa-38">
              <!-- Profile -->
              <v-tabs
                class="my_app_tabs_data"
                v-model="activeTab"
                dense
                hide-slider
                grow
              >

                <v-tab href="#tab-1" class="tab_btn" @click="title = $t('user.agent.detail.fields.profile')">{{$t('user.agent.detail.fields.profile')}}</v-tab>
                <v-tab href="#tab-2" class="tab_btn" @click="title = $t('user.agent.detail.fields.applications')">{{$t('user.agent.detail.fields.applications')}}</v-tab>

                <v-tabs-items v-model="activeTab" touchless>
                  <v-tab-item value="tab-1">
                    <div class="inner_item_content bd_none pa-0 mt-15">
                      <v-row>
                        <v-col cols="12" class="pt-0 pb-0">
                          <h2 class="m_title">{{ $t('user.agent.detail.fields.email') }}</h2>
                          <div class="input_text_type_basic pa-20 pt-0 pb-0">
                            <v-row>
                              <v-col class="ft-size12 d-flex align-center" cols="12" md="6">
                                {{ email }}
                                <v-spacer class="hidden_lr5"></v-spacer>
                                <v-btn
                                  style="max-height:25px"
                                  dark
                                  color="#00af50"
                                  class="ft-size12 text-capitalize btn-normal"
                                  v-if="!lasted_login_date || user_status_type_code === '3501'"
                                  :loading="isBtnLoading"
                                  @click="fnResendEmail()"
                                >
                                  {{$t('user.agent.detail.fields.e-mail_resend')}}
                                </v-btn>
                              </v-col>
                              <v-col cols="12" md="2" class="pa-0 mt-15">
                                <v-select
                                  dense
                                  outlined
                                  class="ft-size12 br_none"
                                  v-if="lasted_login_date && ind_representative !== 'Y'"
                                  v-model="user_status_type_code"
                                  :items="user_status_type_code_list"
                                >
                                </v-select>
                              </v-col>
                            </v-row>
                          </div>
                        </v-col>
                        <v-col cols="12" class="pt-0">
                          <h2 class="m_title">{{ $t('user.agent.detail.fields.agent_no') }}</h2>
                          <v-row class="pa-20 pb-0 pt-15">
                            <v-col class="pt-0 pb-0 ft-size12">{{ agent_no }}</v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" class="pt-0">
                          <h2 class="m_title">{{ $t('user.agent.detail.fields.name_en') }}</h2>
                          <v-row class="pa-20 pb-0 pt-15">
                            <v-col class="pt-0 pb-0 ft-size12">{{ name_en }}</v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" class="pt-0">
                          <h2 class="m_title">{{ $t('user.agent.detail.fields.name_ar') }}</h2>
                          <v-row class="pa-20 pb-0 pt-15">
                            <v-col class="pt-0 pb-0 ft-size12">{{ name_ar }}</v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" class="pt-0">
                          <h2 class="m_title">{{ $t('user.agent.detail.fields.authorization') }}</h2>
                          <v-row class="pa-20 pb-0 pt-0">
                            <v-col class="pt-0 pb-0 ft-size12">
                              <v-radio-group v-model="agent_authorization_type_code">
                                <v-flex class="radio_bx">
                                  <v-label>
                                    <v-radio
                                      color="#a01c2a"
                                      value="2801"
                                    ></v-radio>
                                    <v-spacer class="hidden_lr2"></v-spacer>
                                    <v-icon color="#a01c2a">mdi-lock-open-outline</v-icon>
                                    <v-spacer class="hidden_lr5"></v-spacer>
                                    {{ $t('user.agent.detail.fields.auth_1') }}
                                  </v-label>
                                </v-flex>
                                <v-flex class="radio_bx">
                                  <v-label>
                                    <v-radio
                                      color="#a01c2a"
                                      value="2802"
                                    ></v-radio>
                                    <v-spacer class="hidden_lr2"></v-spacer>
                                    <v-icon color="#a01c2a">mdi-eye</v-icon>
                                    <v-spacer class="hidden_lr5"></v-spacer>
                                    {{ $t('user.agent.detail.fields.auth_2') }}
                                  </v-label>
                                </v-flex>
                                <v-flex class="radio_bx">
                                  <v-label>
                                    <v-radio
                                      color="#a01c2a"
                                      value="2803"
                                    ></v-radio>
                                    <v-spacer class="hidden_lr2"></v-spacer>
                                    <v-icon color="#a01c2a">mdi-lock</v-icon>
                                    <v-spacer class="hidden_lr5"></v-spacer>
                                    {{ $t('user.agent.detail.fields.auth_3') }}
                                  </v-label>
                                </v-flex>
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <h2 class="m_title"><i>*</i> {{ $t('user.agent.detail.fields.representative') }}</h2>
                          <v-row class="pa-20 pt-0 pb-0">
                            <v-col class="pt-0 pb-0" cols="12">
                              <v-flex class="radio_bx">
                                <v-checkbox
                                  v-model="ind_representative"
                                  color="#a01c2a"
                                  value="Y"
                                  false-value="N"
                                  :label="$t('user.agent.detail.fields.representative')"
                                ></v-checkbox>
                              </v-flex>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" class="login_form login_content type2" v-if="user_group_type_code === '3803' && ind_representative === 'Y'">
                          <div class="d-flex ft-size13 ft-medium color_red" v-html="$t('user.agent.members.fields.representative_patent_attorney_information_msg')"></div>
                          <h2 class="m_title">{{ $t('signup.agent.regist.fields.representative_patent_attorney_information') }}</h2>
                          <v-card-text class="pa-0 inner_item_content">
                            <v-row class="ma-0">
                              <v-col cols="12" class="pa-35 pb-0 pr-0">
                                <h2 class="nec_title mb-15">{{ $t('signup.agent.regist.fields.patent_attorney_license_no') }}</h2>
                                <v-text-field
                                  label=""
                                  v-model="agent_no"
                                  solo
                                  outlined
                                  flat
                                  dense
                                  clearable
                                  class="login_text_filed"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row class="ma-0">
                              <v-col cols="12" class="pa-35 pb-0 pt-0 pr-0">
                                <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.agent.regist.fields.agent_type') }}</h2>
                                <v-select
                                  :items="$vuetify.rtl ? agentTypeCodeListAr : agentTypeCodeListEn"
                                  v-model="agent_type_code"
                                  v-validate="{required: true}"
                                  :error-messages="errors.collect('scope_profile.agent_type_code')"
                                  name="agent_type_code"
                                  solo
                                  flat
                                  outlined
                                  dense
                                  class="ft-size12 bdr_none"
                                ></v-select>
                              </v-col>
                            </v-row>
                            <v-row class="ma-0">
                              <v-col cols="12" class="pa-35 pt-0 pr-0">
                                <h2 class="nec_title mb-15"><i>*</i> {{ $t('user.profile.fields.nationality') }}</h2>
                                <v-select
                                  v-model="nationality_code"
                                  :items="$vuetify.rtl ? countryArList : countryEnList"
                                  v-validate="{required: true}"
                                  :error-messages="errors.collect('scope_profile.nationality_code')"
                                  name="nationality_code"
                                  solo
                                  flat
                                  outlined
                                  dense
                                  class="ft-size12 bdr_none"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-col>
                        <v-col cols="12" class="d-flex">
                          <v-spacer></v-spacer>
                          <v-btn class="button-size-1 btn-actv type2 reverse" rounded @click="fnEditAgentMember()">{{$t('common.button.edit')}}</v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </v-tab-item>

                  <!-- Applications -->
                  <v-tab-item value="tab-2">
                    <v-card-text class="pa-0 inner_item_content bd_none modal_type_table mt-15">
                      <v-data-table
                        :headers="$getHeaderType1(headerTxt, headers)"
                        :items="applications"
                        hide-default-footer
                        class="new__type__table ty7"
                        :page.sync="paging.page"
                        :items-per-page="paging.pageSize"
                        @page-count="paging.pageCount = $event"
                        show-select
                        v-model="selected"
                        item-key="application_seq"
                        :mobile-breakpoint="MobileBreakPoint"
                      >
                        <template v-slot:item.application_no="{ item }">
                          <p>
                            {{ item.application_no }}&nbsp;
                            <span v-if="item.filing_date">
                              ({{ item.filing_date }})
                            </span>
                          </p>
                          <p>{{ $vuetify.rtl ? item.title_ar : item.title_en }}</p>
                        </template>
                        <template v-slot:item.grant_no="{ item }">
                          <p>
                            {{ item.grant_no }}&nbsp;
                            <span v-if="item.grant_date">
                              ({{ item.grant_date }})
                            </span>
                          </p>
                        </template>
                        <template v-slot:item.certification_ar_file_key="{ item }">
                          <v-icon color="#FF0000" v-if="item.certification_ar_file_key" @click="fnShowCertFile(item)">mdi-certificate</v-icon>
                          <v-icon v-if="item.grant_no && !item.certification_ar_file_key" @click="fnShowCertFile(item)">mdi-certificate</v-icon>
                        </template>
                        <template v-slot:item.status_name_en="{ item }">
                          <p>
                            {{ $vuetify.rtl ? item.status_name_ar : item.status_name_en }}
                          </p>
                        </template>
                      </v-data-table>

                      <div class="v-data-table-footer page_nation_wrap">
                        <pagination :paging.sync="paging" />
                      </div>

                      <v-card-actions class="pl-0 pr-0 mt-25">
                        <v-spacer></v-spacer>
                        <v-btn
                          class="button-size-1 btn-actv type2 reverse"
                          rounded
                          @click="fnOpenSearchAgent()"
                          style="max-width: 270px !important;width: 270px;"
                        >
                          {{$t('user.agent.detail.fields.change_btn')}}
                        </v-btn>
                      </v-card-actions>
                    </v-card-text>


                    <v-dialog
                      v-model="dialog_search_agent"
                      flat
                      max-width="700"
                    >
                      <v-row class="modal__content__wrapper">
                        <v-col cols="12" class="pa-0">
                          <div class="header__wrap">
                            <div>
                              <h2 class="modal__title">{{$t('user.agent.detail.fields.change_agent_title')}}</h2>
                            </div>
                            <div class="modal__close__wrap">
                              <v-btn @click="dialog_search_agent = false"></v-btn>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <div class="modal__content__inner__new pa-38 pt-15 pb-0">
                            <v-data-table
                              :headers="$getHeaderType1(headerAgentTxt, agentHeaders)"
                              :items="search_result"
                              hide-default-footer
                              class="new__type__table"
                              :page.sync="agentPaging.page"
                              :items-per-page="agentPaging.pageSize"
                              @page-count="agentPaging.pageCount = $event"
                              item-key="seq"
                              v-model="charge_user"
                              show-select
                              single-select
                              :mobile-breakpoint="MobileBreakPoint"
                            >
                            </v-data-table>
                          </div>
                          <v-layout class="login_wrap type2 modal_type pt-0 pb-30 pl-40 pr-40">
                            <v-spacer></v-spacer>
                            <v-btn
                              class="mt-10 button-size-1 btn-actv type2 reverse"
                              rounded
                              @click="fnChangeAgent()"
                            >
                              {{$t('common.button.submit')}}
                            </v-btn>
                          </v-layout>
                        </v-col>
                      </v-row>
                    </v-dialog>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </div>
          </v-form>
        </v-col>
      </v-row>
    </v-dialog>
    <v-dialog  v-model="compnonent_dialog" flat persistent max-width="900" content-class="br_none">
      <v-card class="br_none modal_comfirm_wrap type4 pb-0">
        <v-btn class="modal_close" @click="compnonent_dialog = false" fab color="white">
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
        <h2 class="header_title02 type4">{{$t('myapplication.fields.certification')}}</h2>
      </v-card>
      <v-layout class="login_wrap type2 modal_type ma-0 pb-5">
        <v-flex class="pl-5 pr-5 pt-0 ma-0 login_content type2">
          <pdf-viewer height="550px" :url="pdfUrl"></pdf-viewer>
        </v-flex>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/layout/Pagination'
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import PdfViewer from '@/components/layout/PdfViewer.vue'

export default {
  name: 'AgentMemberDetails',
  props: {
    seq: {
      type: Number
    },
    tab: {
      type: String
    },
    dialog: {
      type: Boolean
    }
  },
  components :{
    Pagination,
    PdfViewer
  },
  data () {
    return {
      MobileBreakPoint : 0,
      dialog_search_agent : false,
      isBtnLoading : false,
      company_seq : '',
      email : '',
      lasted_login_date : '',
      login_failed_count : '',
      account_lock_date : '',
      user_status_type_code : '',
      name_ar : '',
      name_en : '',
      personal_identify_no : '',
      valid_until_date : '',
      strong_auth_type_code : '',
      user_group_type_code : '',
      user_type_code : '',
      agent_no : '',
      agent_type_code: '',
      birthday_date : '',
      gender_type_code : '',
      id_card_file_key : '',
      address_ar : '',
      address_en : '',
      city_name_ar : '',
      city_name_en : '',
      residence_country_code : '',
      pobox : '',
      postal : '',
      nationality_code : '',
      telephone : '',
      mobile : '',
      fax : '',
      avatar_file_key : '',
      sign_image : '',
      ind_representative : '',
      agent_authorization_type_code : '',

      agentTypeCodeListAr: [],
      agentTypeCodeListEn: [],
      countryEnList: [],
      countryArList: [],

      title : '',
      activeTab : 'tab-1',

      headerTxt : {
        prefix : 'user.agent.detail.fields.',
        txt : [
          'application_no_title',
          'patent_no',
          'certification',
          'status'
        ]
      },

      headers : [
        {
          text: 'Application No. (Filling Date) Title',
          align: 'start',
          value: 'application_no'
        },
        {
          text: 'Patent No. (Patent Date)',
          align: 'center',
          value: 'grant_no',
          width: 150
        },
        {
          text: 'Certification',
          align: 'center',
          value: 'certification_ar_file_key',
          sortable: false,
          width: 120
        },
        {
          text: 'Status',
          align: 'center',
          value: 'status_name_en',
          width: 200
        }
      ],

      headerAgentTxt : {
        prefix : 'user.agent.members.fields.',
        txt : [ 'e_mail','english_name','arabic_name' ]
      },
      agentHeaders : [
        {
          text: 'e-mail',
          align: 'center',
          value: 'email'
        },
        {
          text: 'English Name',
          align: 'center',
          value: 'name_en'
        },
        {
          text: 'Arabic Name',
          align: 'center',
          value: 'name_ar'
        }

      ],

      applications : [],

      paging: {
        page: 1,
        pageSize: 10,
        pageCount: 0,
        totalCount: 0
      },
      agentPaging:{
        page: 1,
        pageSize: 10,
        pageCount: 0,
        totalCount: 0
      },

      selected : [],
      search_string : '',
      search_result : [],

      charge_user : [],
      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',
      pdfUrl: '',
      compnonent_dialog : false,
    }
  },
  computed: {
    user_status_type_code_list () {
      let list = [
        {value : '3502', text : this.$t('user.agent.detail.fields.active')},
        {value : '3501', text : this.$t('user.agent.detail.fields.in_active')}
      ]
      return list
    }
  },
  mounted(){
    this.activeTab = 'tab-1'
    this.fnGetAgentTypeCodeList()
    this.fnGetCountryCodeList()
  },
  watch: {
    dialog (val) {
      if (val) {
        this.fnGetMemberDetail()
      }
    }
  },
  methods: {
    fnGetCountryCodeList() {
      utils.fnGetCountryList('en').then(list => {
        this.countryEnList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      utils.fnGetCountryList('ar').then(list => {
        this.countryArList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })
    },
    fnGetAgentTypeCodeList() {
      let options = {
        upper_code: '3100'
      }
      utils.fnGetCodeList(options).then(list => {
        this.agentTypeCodeListAr = list.ar
        this.agentTypeCodeListEn = list.en
      })
    },
    fnGetMemberDetail(){
      requestApi({
        url: '/users/agent/offices/users/'+this.seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.company_seq = res.data.company_seq
            this.email = res.data.email
            this.lasted_login_date = res.data.lasted_login_date
            this.login_failed_count = res.data.login_failed_count
            this.account_lock_date = res.data.account_lock_date
            this.user_status_type_code = res.data.user_status_type_code
            this.name_ar = res.data.name_ar
            this.name_en = res.data.name_en
            this.personal_identify_no = res.data.personal_identify_no
            this.valid_until_date = res.data.valid_until_date
            this.strong_auth_type_code = res.data.strong_auth_type_code
            this.user_group_type_code = res.data.user_group_type_code
            this.user_type_code = res.data.user_type_code
            this.agent_no = res.data.agent_no
            this.agent_type_code = res.data.agent_type_code
            this.birthday_date = res.data.birthday_date
            this.gender_type_code = res.data.gender_type_code
            this.id_card_file_key = res.data.id_card_file_key
            this.address_ar = res.data.address_ar
            this.address_en = res.data.address_en
            this.city_name_ar = res.data.city_name_ar
            this.city_name_en = res.data.city_name_en
            this.residence_country_code = res.data.residence_country_code
            this.pobox = res.data.pobox
            this.postal = res.data.postal
            this.nationality_code = res.data.nationality_code
            this.telephone = res.data.telephone
            this.mobile = res.data.mobile
            this.fax = res.data.fax
            this.avatar_file_key = res.data.avatar_file_key
            this.sign_image = res.data.sign_image
            this.ind_representative = res.data.ind_representative
            this.agent_authorization_type_code = res.data.agent_authorization_type_code

            this.fnGetApplicationList()
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetMemberDetail()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetApplicationList(){
      requestApi({
        url: '/users/agent/offices/users/'+this.seq+'/applications',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }

            this.paging.totalCount = res.data.list.length

            this.applications = res.data.list

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetApplicationList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnEditAgentMember(){
      this.$validator.validateAll('scope_profile').then((result) => {
        if(result) {
          if(!this.ind_representative){
            this.ind_representative = 'N'
          }

          let params = {
            ind_representative : this.ind_representative,
            user_status_type_code : this.user_status_type_code,
            agent_authorization_type_code : this.agent_authorization_type_code,
            agent_type_code: this.agent_type_code,
            agent_no: this.agent_no,
            nationality_code: this.nationality_code
          }

          requestApi({
            url: '/users/agent/offices/users/'+this.seq,
            method: 'PUT',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                let snackBarOptions = {
                  text: this.$t('common.message.modify.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
                this.$emit('success')
              } else {
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnEditAgentMember()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        }
      })
    },

    fnResendEmail() {
      this.isBtnLoading = true
      requestApi({
        url: '/users/agent/offices/users/'+ this.seq +'/mail/register',
        method: 'POST',
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('user.agent.add.fields.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.isBtnLoading = false
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnResendEmail()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              this.isBtnLoading = false
            }
          }
        }
      })
    },

    fnOpenSearchAgent(){

      //선택된 데이터 테이블의 길이가 0보다 크다면
      if(this.selected.length > 0 ){
        this.charge_user = []
        this.search_string = ''
        this.search_result = []

        //검색 창을 보여주던 영역에 검색 결과를 뿌리는 것으로 바꿔준다...
        this.fnSearchAgent()
      }else{
        let snackBarOptions = {
          text: this.$t('user.agent.detail.fields.no_data_selected')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
      }
    },

    fnSearchAgent(){
      this.search_result = []

      requestApi({
        url: '/users/agent/offices/users',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.search_result = res.data.list
            this.agentPaging.pageSize = res.data.list.length

            this.dialog_search_agent = true
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSearchAgent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnChangeAgent(){
      if(this.charge_user.length <= 0){
        let snackBarOptions = {
          text: this.$t('user.agent.detail.fields.no_agent_selected')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

        return false
      }

      if(this.selected.length == 0){
        let snackBarOptions = {
          text: this.$t('user.agent.detail.fields.no_data_selected')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

        return false
      }

      let application_seqs = []

      for(let i=0; i < this.selected.length; i++){
        application_seqs.push(this.selected[i].application_seq)
      }

      let params = {
        application_seqs : application_seqs,
        charge_user_seq : this.charge_user[0].seq
      }

      requestApi({
        url: '/users/agent/offices/user/'+this.seq+'/applications/change',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {

            let snackBarOptions = {
              text: this.$t('common.message.modify.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            //적용 후 초기화
            this.dialog_search_agent = false
            this.applications = []
            this.selected = []
            this.search_string = ''
            this.search_result = []
            this.charge_user = []

            this.fnGetApplicationList()
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnChangeAgent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnShowCertFile(item){
      if (item.certification_ar_file_key) {
        this.pdfUrl = this.downLoadUrl + item.certification_ar_file_key +'/pdf/'+ item.certification_ar_file_name
        this.compnonent_dialog = true
      } else {
        let option = {
          text : this.$t('common.message.certification_error'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)
      }
    },
  }
}
</script>